function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m628.94 249.49-125.04-153.89c-7.875-9.707-20.59-13.289-32.402-9.1055-11.785 4.1836-19.414 14.984-19.414 27.48v75.605h-269.77c-36.176 0-65.625 29.449-65.625 65.625s29.449 65.625 65.625 65.625h412.67c17.035 0 32.184-9.543 39.512-24.938 7.3281-15.395 5.1953-33.168-5.5508-46.402z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m517.7 379.18h-412.67c-17.035 0-32.184 9.543-39.512 24.938s-5.1953 33.168 5.5508 46.402l125.04 153.89c5.7148 7.0273 13.918 10.828 22.477 10.828 3.3086 0 6.6445-0.57422 9.9258-1.7227 11.785-4.1836 19.414-14.984 19.414-27.48v-75.605h269.8c36.176 0 65.625-29.449 65.625-65.625s-29.449-65.625-65.625-65.625z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transfer_icon.b7a50d4eaadd83d144fd3f77b594a83d.svg";
export { ForwardRef as ReactComponent };